import React, {useEffect, useState} from "react";
import axios from "axios";
import "../styles/CourseCreateForm.css";

export default function CourseCreateForm() {
    const [form, setForm] = useState({
        name: "",
        description: "",
        startDate: "",
        endDate: "",
        duration: "01:00:00",
        price: 0,
        termId: "",
        imagePath: "",
        registrationStartDate: "",
        registrationEndDate: "",
        capacityMin: 15,
        capacityMax: 250,
        language: "Türkçe",
        certificateType: "Katılım Sertifikası",
        courseCode: "",
        coordinator: ""
    });

    const [terms, setTerms] = useState([]);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/terms`)
            .then((res) => setTerms(res.data))
            .catch((err) => console.error("Dönemler alınamadı:", err));
    }, []);

    const handleChange = (e) => {
        const {name, value} = e.target;
        setForm({...form, [name]: value});
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const payload = {
            ...form,
            term: {id: form.termId}
        };
        delete payload.termId;

        axios.post(`${process.env.REACT_APP_API_URL}/courses/create`, payload)
            .then(() => alert("Kurs başarıyla eklendi!"))
            .catch((err) => alert("Hata: " + err.message));
    };

    return (
        <form onSubmit={handleSubmit} className="course-create-form">
            <h2>Yeni Kurs Ekle</h2>

            <label>Kurs Adı</label>
            <input type="text" name="name" value={form.name} onChange={handleChange} required/>

            <label>Açıklama</label>
            <textarea name="description" value={form.description} onChange={handleChange} required/>

            <label>Başlangıç Tarihi</label>
            <input type="date" name="startDate" value={form.startDate} onChange={handleChange} required/>

            <label>Bitiş Tarihi</label>
            <input type="date" name="endDate" value={form.endDate} onChange={handleChange} required/>

            <label>Ders Süresi</label>
            <input type="time" name="duration" value={form.duration} onChange={handleChange} step="1" required/>

            <label>Kayıt Başlangıç Tarihi</label>
            <input type="date" name="registrationStartDate" value={form.registrationStartDate} onChange={handleChange}
                   required/>

            <label>Kayıt Bitiş Tarihi</label>
            <input type="date" name="registrationEndDate" value={form.registrationEndDate} onChange={handleChange}
                   required/>

            <label>Minimum Kontenjan</label>
            <input type="number" name="capacityMin" value={form.capacityMin} onChange={handleChange} required/>

            <label>Maksimum Kontenjan</label>
            <input type="number" name="capacityMax" value={form.capacityMax} onChange={handleChange} required/>

            <label>Dil</label>
            <input type="text" name="language" value={form.language} onChange={handleChange} required/>

            <label>Sertifika Türü</label>
            <input type="text" name="certificateType" value={form.certificateType} onChange={handleChange} required/>

            <label>Ders Kodu</label>
            <input type="text" name="courseCode" value={form.courseCode} onChange={handleChange} required/>

            <label>Ders Koordinatörü</label>
            <input type="text" name="coordinator" value={form.coordinator} onChange={handleChange} required/>

            <label>Görsel Yolu (image path)</label>
            <input type="text" name="imagePath" value={form.imagePath} onChange={handleChange} required/>

            <label>Dönem</label>
            <select name="termId" value={form.termId} onChange={handleChange} required>
                <option value="">Dönem Seçin</option>
                {terms.map((term) => (
                    <option key={term.id} value={term.id}>{term.name}</option>
                ))}
            </select>

            <label>Fiyat</label>
            <input type="number" name="price" value={form.price} onChange={handleChange} min="0" required/>

            <button type="submit">Kaydet</button>
        </form>
    );
}
